import React from 'react';
import { format } from 'date-fns';

const AccessLogsTab = ({
  accessLogs,
  accessLogsLoading,
  totalLogs,
  currentPage,
  logsPerPage,
  logFilters,
  users,
  handleLogFilterChange,
  applyLogFilters,
  formatActionName,
  formatMetadata
}) => {
  return (
    <div className="enterprise-admin-access-logs-tab">
      <h2>Journaux d'accès</h2>
      
      {/* Filters */}
      <div className="enterprise-admin-filters">
        <div className="enterprise-admin-filter-row">
          <div className="enterprise-admin-filter-group">
            <label>Date de début:</label>
            <input
              type="date"
              value={logFilters.startDate}
              onChange={(e) => handleLogFilterChange('startDate', e.target.value)}
            />
          </div>
          <div className="enterprise-admin-filter-group">
            <label>Date de fin:</label>
            <input
              type="date"
              value={logFilters.endDate}
              onChange={(e) => handleLogFilterChange('endDate', e.target.value)}
            />
          </div>
          <div className="enterprise-admin-filter-group">
            <label>Action:</label>
            <select
              value={logFilters.action}
              onChange={(e) => handleLogFilterChange('action', e.target.value)}
            >
              <option value="">Toutes les actions</option>
              <optgroup label="Gestion des utilisateurs">
                <option value="login">Connexion</option>
                <option value="logout">Déconnexion</option>
                <option value="invite_user">Invitation utilisateur</option>
                <option value="remove_user">Retrait utilisateur</option>
                <option value="update_admin">Modification statut admin</option>
              </optgroup>
              <optgroup label="Gestion de l'organisation">
                <option value="create_enterprise">Création d'organisation</option>
                <option value="update_enterprise_details">Modification des informations</option>
                <option value="set_active_enterprise">Changement d'organisation active</option>
                <option value="leave_enterprise">Départ de l'organisation</option>
              </optgroup>
              <optgroup label="Rapports">
                <option value="create_report">Création de rapport</option>
                <option value="update_report">Modification de rapport</option>
                <option value="delete_report">Suppression de rapport</option>
                <option value="view_report">Consultation de rapport</option>
                <option value="export_report">Export de rapport</option>
              </optgroup>
              <optgroup label="Modèles organisation">
                <option value="create_enterprise_report_type">Création template</option>
                <option value="update_enterprise_report_type">Modification template</option>
                <option value="delete_enterprise_report_type">Suppression template</option>
              </optgroup>
              <optgroup label="Exemples organisation">
                <option value="create_enterprise_example">Ajout d'exemple</option>
                <option value="update_enterprise_example">Modification d'exemple</option>
                <option value="delete_enterprise_example">Suppression d'exemple</option>
              </optgroup>
            </select>
          </div>
          <div className="enterprise-admin-filter-group">
            <label>Utilisateur:</label>
            <select
              value={logFilters.userId}
              onChange={(e) => handleLogFilterChange('userId', e.target.value)}
            >
              <option value="">Tous les utilisateurs</option>
              {users.map(user => (
                <option key={user.userId} value={user.userId}>
                  {user.fullName} ({user.email})
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={applyLogFilters}
            className="enterprise-admin-filter-btn"
            disabled={accessLogsLoading}
          >
            Appliquer les filtres
          </button>
        </div>
      </div>

      {/* Access Logs Table */}
      {accessLogsLoading ? (
        <p>Chargement des journaux...</p>
      ) : (
        <>
          <div className="enterprise-admin-logs-stats">
            <span>Total: {totalLogs} entrées</span>
            <span>Page {currentPage} sur {Math.ceil(totalLogs / logsPerPage)}</span>
          </div>
          
          <div className="enterprise-admin-logs-table-container">
            <table className="enterprise-admin-logs-table">
              <thead>
                <tr>
                  <th>Date/Heure</th>
                  <th>Utilisateur</th>
                  <th>Action</th>
                  <th>Détails</th>
                </tr>
              </thead>
              <tbody>
                {accessLogs.length > 0 ? (
                  accessLogs.map((log) => (
                    <tr key={log.id}>
                      <td data-label="Date/Heure">
                        {log.createdAt ? format(new Date(log.createdAt), 'dd/MM/yyyy HH:mm:ss') : '-'}
                      </td>
                      <td data-label="Utilisateur">
                        <div className="enterprise-admin-user-info">
                          <div>{log.userFullName}</div>
                          <div className="enterprise-admin-user-email">{log.userEmail}</div>
                        </div>
                      </td>
                      <td data-label="Action">
                        {formatActionName(log.action)}
                      </td>
                      <td data-label="Détails">
                        <div className="enterprise-admin-metadata">
                          {formatMetadata(log.metadata, log.action)}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" style={{ textAlign: 'center', padding: '2rem' }}>
                      Aucun journal d'accès trouvé pour les critères sélectionnés.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default AccessLogsTab; 